export default __webpack_public_path__ + "static/Leader-da7d8f345ded14fde89a8b22d46cde1c.svg";